/* pi-alt-cleaner.js | Pi26: rewrites Salsify-format alts on JS-rendered images. */
(function () {
  var RE = /\|\||color:|view:|gender:|technology:|color_swatch:|fitguide|sizeguide/;
  function cleanAlt(raw) {
    return '';
  }
  function fix(img) {
    var a = img.getAttribute('alt');
    if (a && RE.test(a)) img.setAttribute('alt', cleanAlt(a));
  }
  function scan(root) {
    if (root.tagName === 'IMG') { fix(root); return; }
    if (root.querySelectorAll) root.querySelectorAll('img[alt]').forEach(fix);
  }
  function start() {
    scan(document.body);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes') { if (m.target.tagName === 'IMG') fix(m.target); return; }
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); });
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['alt'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();